export default __webpack_public_path__ + "static/media/q9_step2_2.c9fcd5da.png";